import React from 'react';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

function CustomSwitch(props) {
    const switchProps = { ...props };
    ['withControl', 'formControlProps'].forEach(key => delete switchProps[key]);
    switchProps.value = switchProps.value.toString();

    return props.withControl ?
        <FormControlLabel
            control={<Switch { ...switchProps } />}
            label={<FormattedMessage id={`field.${props.label ? props.label : props.name}.label`} />}
        /> :
        <Switch { ...switchProps } />;
}

CustomSwitch.propTypes = {
    withControl: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string
};

export default CustomSwitch;



// WEBPACK FOOTER //
// ./src/common/CustomSwitch/CustomSwitch.jsx